import React from 'react';
import { betterservice } from "../../utils/assets"
import styles from "../../pages/pages.module.scss";
import FrameCard from '../CommonCard';

const BetterServiceSection = () => {
  return (
    <section className="container">

      <div className="mx-2 mx-md-0 row">
        <div className="align-self-center col-lg-6 mb-4 mb-lg-0 text-center text-lg-start">
          <div className={`${styles.bestserviec}`}>
            <h4>Why Startups and Ecommerce Businesses choose Toola?</h4>
            <h3>Better Service & better price- its that simple</h3>
          </div>
        </div>

        <div className="col-lg-6 align-self-center">
          <div className="row d-flex gap-4">
            {betterservice.map((item, index) => (
              <div key={index} className="col-sm-12">
                <FrameCard>
                  <div className={`d-flex align-items-md-start text-start gap-3 ${styles.securitynotes}`}>
                    <img src={item.icon} alt='' />
                    <div>
                      <h6>{item.text}</h6>
                      <p>{item.content}</p>
                    </div>
                  </div>
                </FrameCard>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  )
}

export default BetterServiceSection;